import { render, staticRenderFns } from "./CandidatesReservedExchangedPage.vue?vue&type=template&id=8ebdf89a&scoped=true&lang=pug"
import script from "./CandidatesReservedExchangedPage.vue?vue&type=script&lang=js"
export * from "./CandidatesReservedExchangedPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesReservedExchangedPage.vue?vue&type=style&index=0&id=8ebdf89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebdf89a",
  null
  
)

export default component.exports